import { Divider, Flex, theme } from '@/components';
import type { FC } from 'react';
import { BudgetAmountsTable } from './BudgetAmountsTable';
import { CurrentFinalizedAmountFormDrawer } from './CurrentFinalizedAmountFormDrawer';
import { PreviousFiscalYearExecutedFormDrawer } from './PreviousFiscalYearExecutedFormDrawer';
import { ProjectOtherNotesFormDrawer } from './ProjectOtherNotesFormDrawer';
import { ProjectOtherNotesInformation } from './ProjectOtherNotesInformation';

export const SsProjectDetailedBreakdown: FC = () => {
  const { token } = theme.useToken();
  return (
    <Flex vertical gap={16}>
      <BudgetAmountsTable />
      <Divider style={{ border: `2px solid ${token.colorSplit}` }} />
      <ProjectOtherNotesInformation />
      <ProjectOtherNotesFormDrawer />
      <PreviousFiscalYearExecutedFormDrawer />
      <CurrentFinalizedAmountFormDrawer />
    </Flex>
  );
};
